// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'

import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.use(VueLazyload, {//图片懒加载
  preLoad: 1.3,
  error: './static/img/error.png',
  loading: './static/img/loading.gif',
  attempt: 1
})
Vue.config.productionTip = false
axios.defaults.withCredentials = true
Vue.prototype.$http = axios
Vue.prototype.$api = ''
Vue.prototype.$transtime = (timestamp) => {
  return new Date(parseInt(timestamp) * 1000).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ");
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js